import React, { useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactWizard from "react-bootstrap-wizard";
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useGuestContext } from '../../../../contexts/GuestContext.js';
import Step1 from "./Step1.js";
import Step2 from "./Step2.js";
import Step3 from "./Step3.js";
import { useWizard } from './WizardContext.js';
import { LIANG_HUANG_EVENT } from '../../../../config/liangHuang2026.js';

function RegistrationWizardContent() {
  const [alertState, setAlertState] = React.useState(false);
  const { language, setPageBanner, setLoading } = useGuestContext();
  const history = useHistory();
  const { firstname, lastname, chinesename, email, phone, sessionSelections } = useWizard();

  const steps = [
    { stepName: language === "English" ? "Personal" : "個人信息", component: Step1 },
    { stepName: language === "English" ? "Sessions" : "共修時段", component: Step2 },
    { stepName: language === "English" ? "Confirm" : "信息確認", component: Step3 },
  ];

  const handleRegistration = async () => {
    try {
      setLoading(true); // Start loading
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/event/register-guest`, {
        firstname,
        lastname,
        chinesename,
        email,
        phone,
        "checkedIn": false,
        ...sessionSelections,
      });
      console.log('Registration successful:', response.data);
      setLoading(false);
      // Additional success handling here
      if (response.status === 200 && response.data.status === "success") {
        const guestId = response.data.guestid;

        setAlertState(<SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title={language === "English" ? "Amituofo" : "阿彌陀佛"}
          onConfirm={() => {
            handleAlertConfirm(guestId, sessionSelections);
          }}
          confirmBtnBsStyle="warning"
          confirmBtnText={language === "English" ? "View Your Ticket Information" : "查看您的入場券信息"}
        >
          {language === "English" ?
            "You have completed the event registration. Your Guest ID is " + guestId + ". Keep your Guest ID or QR code for check-in." :
            "恭喜您完成報名! 您的入場券號碼是 " + guestId + "。請保存您的Guest ID或二維碼，以利法會當天報到"}
        </SweetAlert>);
      }
    }
    catch (error) {
      console.error('Registration failed:', error);
      setLoading(false); // Stop loading
      // Additional error handling here
      if (error.response && error.response.data && error.response.data.detail) {
        const detail = error.response.data.detail;

        // Check if it's a duplicate entry error
        if (detail.status === 'fail' && detail.reason === 'Duplicate entry') {
          const guestId = detail.guestid;

          setAlertState(
            <SweetAlert
              warning
              showCancel={true}
              style={{ display: "block", marginTop: "-100px" }}
              title={language === "English" ? "Sorry..." : "抱歉"}
              onConfirm={() => {
                handleAlertConfirm(guestId);
              }}
              onCancel={() => setAlertState(null)}
              cancelBtnText={language === "English" ? "Check My Information Again" : "重新驗證我的信息"}
              cancelBtnBsStyle="error"
              confirmBtnBsStyle="warning"
              confirmBtnText={language === "English" ? "View Ticket" : "查看入場券"}
            >
              {language === "English" ?
                "The guest you have registered is already signed up. If you are sure that the information filled in is correct, you can click to view the event ticket." :
                "您填寫的報名資料已經受理過。 如果您確定所填信息無誤，可以點擊查看入場券。"}
            </SweetAlert>
          );
        } else {
          setLoading(false);
          // Handle other types of errors
          setAlertState(<SweetAlert
            error
            showCancel={true}
            style={{ display: "block", marginTop: "-100px" }}
            title={language === "English" ? "Sorry..." : "抱歉"}
            onCancel={() => setAlertState(null)}
            onConfirm={() => setAlertState(null)}
            cancelBtnText={language === "English" ? "I will contact Bao Lin" : "我會聯繫寶林"}
            cancelBtnBsStyle="error"
          >
            {language === "English" ?
              "Unknown issue encounted!! Please contact Bao Link for further assistance" :
              "抱歉出現了未知錯誤，請聯繫寶林尋求幫助"}
          </SweetAlert>);
        }
      }
    }

  };

  useEffect(() => {
    setPageBanner(1);
  }, [setPageBanner]);

  const handleAlertConfirm = (guestId, selectedSessions) => {
    setAlertState(null);
    history.push({
      pathname: '/event-ticket',
      state: { guestId, sessionSelections: selectedSessions }
    });
    // Construct the URL for the new tab
    // const url = new URL('/event-ticket', window.location.href);
    // url.searchParams.append('guestId', guestId);

    // Open the new tab
    // window.open(url.href, '_blank');
    window.scrollTo(0, 0);
  };

  return (
    <>
      <ReactWizard
        steps={steps}
        navSteps
        title={LIANG_HUANG_EVENT.title[language]}
        description={language === "English" ? "Please complete the information below" : "請完成以下報名信息"}
        headerTextCenter
        validate
        color="orange"
        previousButtonText={language === "English" ? "Previous" : "上一步"}
        nextButtonText={language === "English" ? "Next" : "下一步"}
        finishButtonText={language === "English" ? "Submit" : "提交"}
        finishButtonClasses="btn-warning btn-wd"
        nextButtonClasses="btn-warning btn-wd"
        previousButtonClasses="btn-wd"
        finishButtonClick={handleRegistration}
      />
      {alertState}

    </>
  );
}

export default RegistrationWizardContent;
